// extracted by mini-css-extract-plugin
export default {"preview-container":"styles_preview-container__p6MIm","frame":"styles_frame__ifd3z"};